import { useReactiveVar } from "@apollo/client";
import { Form, Button, DatePicker } from "antd";
import dayjs from "dayjs";
import fileDownload from "js-file-download";
import { useState, useEffect } from "react";
import { Dispatch, SetStateAction } from "react";

import Spinner from "../../../components/layout/spinner/Spinner";
import NoPermission from "../../../components/others/NoPermission";
import ContentTitle from "../../../components/ui/ContentTitle";
import { useGetUserProgramsByServiceQuery } from "../../../graphql/operations/get-user-program-by-service";
import {
  __currentUser__,
  __jwtToken__,
  __projectKey__,
} from "../../../graphql/policies";
import { ServiceTypes } from "../../../types/types";
import { apiCall } from "../../../utils/apiCall";
import requiredRule from "../../../utils/formRules/requiredRule";
import { renderDecodedId } from "../../../utils/renderDecodedId";
import "./EALMVendorPerformance.scss";

interface EALMVendorPerformanceProps {
  setSelectedService: Dispatch<SetStateAction<ServiceTypes>>;
  setSelectSubItem: Dispatch<SetStateAction<string | undefined>>;
}

const EALMVendorPerformance = ({
  setSelectedService,
  setSelectSubItem,
}: EALMVendorPerformanceProps) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const currentUser = useReactiveVar(__currentUser__);
  const jwtToken = useReactiveVar(__jwtToken__);
  const projectKey = useReactiveVar(__projectKey__);
  const { data: userPrograms, loading: userProgramsLoading } =
    useGetUserProgramsByServiceQuery({
      variables: {
        userId: parseInt(renderDecodedId(currentUser?.id)),
        serviceId: 4,
      },
    });

  useEffect(() => {
    setSelectedService(ServiceTypes.MKT);
    setSelectSubItem("EALM Vendor Performance");
  }, []);

  const handleSubmit = () => {
    form
      .validateFields()
      .then(async () => {
        setIsLoading(true);
        const { start, end } = form.getFieldsValue();
        const header = {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "X-Project-Id": "AF",
            "X-Authorization-Provider": "Anonymous",
            "X-Project-Key": projectKey,
          },
          responseType: "blob",
        };
        const data = await apiCall({
          method: "GET",
          header: header,
          endPoint:
            process.env.REACT_APP_ADMIN_API + "Af/GetEALMVendorDevelop/VendorDevelop" +
            "/" +
            dayjs(start).format("YYYY-MM-DD") +
            "/" +
            dayjs(end).format("YYYY-MM-DD"),
        });
        fileDownload(data, `EALM活動廠商開發成效表.xlsx`);
        setIsLoading(false);
      })
      .catch((e) => console.log(e));
  };

  if (userProgramsLoading) {
    return <Spinner />;
  }

  if (
    userPrograms &&
    !userPrograms.wf_adminFirst_afUserProgram?.edges?.find(
      (item) => item.node.afProgram?.programName === "EALM Vendor Performance"
    )
  ) {
    return <NoPermission />;
  }

  return (
    <div id="ealmVendorPerformanceWrapper">
      <ContentTitle title="EALM活動廠商開發成效表" />
      <div className="table-container">
        <Form form={form} name="ealm-bonus-form" className="form">
          <div className="flex">
            <Form.Item
              name="start"
              rules={[requiredRule]}
              label="Start Date"
              className="item"
            >
              <DatePicker className="w-full" />
            </Form.Item>
            <Form.Item
              name="end"
              rules={[requiredRule]}
              label="End Date"
              className="ms-5 item"
            >
              <DatePicker className="w-full" />
            </Form.Item>
            <Button
              type="primary"
              className="ms-5"
              onClick={handleSubmit}
              loading={isLoading}
            >
              Submit
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default EALMVendorPerformance;
